import { CustomerNamePipe } from '../pipes/customer-name.pipe';
import { Customer } from '../../models';

export function customerNameComparatorFactory(
  customerNamePipe: CustomerNamePipe
) {
  return (valueA: Customer, valueB: Customer) => {
    return customerNamePipe
      .transform(valueA)
      .localeCompare(customerNamePipe.transform(valueB));
  };
}
